(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  const headers = document.querySelectorAll(".accordion-item .accordion-header");

  headers.forEach(header => {
    header.addEventListener("click", () => {
      const item = header.parentElement;

      // toggle active class
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      } else {
        document.querySelectorAll(".accordion-item").forEach(i => i.classList.remove("active"));
        item.classList.add("active");
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
